import React from 'react';

import styles from './styles.module.css';
import Arrow from '@/assets/icons/arrow.svg?react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  id?: string;
  customClass?: string;
  customLabelClass?: string;
  customSelectClass?: string;
  customSelectWrapperClass?: string;
  readOnly?: boolean;
  withIcon?: boolean;
}

const Select: React.FC<SelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false,
  disabled = false,
  error,
  id,
  customClass = '',
  customLabelClass = '',
  customSelectWrapperClass = '',
  customSelectClass = '',
  readOnly = false,
  withIcon = true
}) => {
  const selectId = id || `select-${label?.toLowerCase()?.replace(/\s+/g, '-')}`;

  return (
    <div className={`${styles.formGroup} ${customClass}`}>
      <label
        id={`${label}-label`}
        htmlFor={selectId}
        className={`${styles.label} ${customLabelClass}`}
      >
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      {readOnly ? (
        <div id={`${label}-select-read-only`} className={styles.selectReadOnly}>
          {value}
        </div>
      ) : (
        <div className={`${styles.selectWrapper} ${customSelectWrapperClass}`}>
          <select
            id={selectId}
            value={value}
            onChange={e => onChange(e.target.value)}
            disabled={disabled}
            className={`${styles.select} ${customSelectClass} ${error ? styles.selectError : ''}`}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${selectId}-error` : undefined}
          >
            {placeholder && (
              <option id={`${label}-placeholder-option`} value="" disabled>
                {placeholder}
              </option>
            )}
            {options.map(option => (
              <option
                id={`${option.label}-option`}
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            ))}
          </select>
          {withIcon && (
            <div
              id={`${label}-icon-container`}
              className={styles.iconContainer}
            >
              <Arrow />
            </div>
          )}
        </div>
      )}

      {error && (
        <span
          id={`${selectId}-error`}
          className={styles.errorMessage}
          role="alert"
        >
          {error}
        </span>
      )}
    </div>
  );
};

export default Select;
